import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { ContinousBaseGesture } from "./gesture";
function changeEventCalculator(current, previous) {
    "worklet";
    var changePayload;
    if (previous === undefined) {
        changePayload = {
            rotationChange: current.rotation
        };
    } else {
        changePayload = {
            rotationChange: current.rotation - previous.rotation
        };
    }
    return _object_spread({}, current, changePayload);
}
export var RotationGesture = /*#__PURE__*/ function(ContinousBaseGesture) {
    "use strict";
    _inherits(RotationGesture, ContinousBaseGesture);
    var _super = _create_super(RotationGesture);
    function RotationGesture() {
        _class_call_check(this, RotationGesture);
        var _this;
        _this = _super.call(this);
        _this.handlerName = "RotationGestureHandler";
        return _this;
    }
    _create_class(RotationGesture, [
        {
            key: "onChange",
            value: function onChange(callback) {
                // @ts-ignore TS being overprotective, RotationGestureHandlerEventPayload is Record
                this.handlers.changeEventCalculator = changeEventCalculator;
                return _get(_get_prototype_of(RotationGesture.prototype), "onChange", this).call(this, callback);
            }
        }
    ]);
    return RotationGesture;
}(ContinousBaseGesture);
